const grecaptcha = (<any>window).grecaptcha || null;
const { CAPTCHA_SITE_KEY } = process.env;
async function generateCaptchaTokenOnSubmit() {
  if (!grecaptcha) return;
  return new Promise((resolve, reject) => {
    try {
      grecaptcha.ready(async () => {
        try {
          const token = await grecaptcha.execute(CAPTCHA_SITE_KEY);
          resolve(token);
        } catch {
          reject();
        }
      });
    } catch {
      reject();
    }
  });
}

export { generateCaptchaTokenOnSubmit };
